import { render, staticRenderFns } from "./VerificaNoteDettaglioItem.vue?vue&type=template&id=87bd0566&"
import script from "./VerificaNoteDettaglioItem.vue?vue&type=script&lang=js&"
export * from "./VerificaNoteDettaglioItem.vue?vue&type=script&lang=js&"
import style0 from "./VerificaNoteDettaglioItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/VerificaNoteDettaglioItem.vue
// module id = 395
// module chunks = 0